import { Link } from 'react-router';

import { getClassName } from '@perpay-web/utils/domUtils';
import { pathIsInternalToApp } from '@perpay-web/utils/routeUtils';

import styles from './PerpayLogo.scss';

const PerpayLogo = ({
    replace = false,
    href,
    hasPerpayPlus = false,
    className = '',
}) => (
    <Link
        reloadDocument={!pathIsInternalToApp(href)}
        replace={replace}
        className={styles['logo-link']}
        to={href}
        aria-label='Go to the home page'
    >
        <div
            className={getClassName(
                hasPerpayPlus
                    ? styles['perpay-plus-logo']
                    : styles['default-logo'],
                className,
            )}
        />
    </Link>
);

export default PerpayLogo;
